import qrcode from "../lib/qrcode";
import url from 'c-url';
import React, { Component } from "react";
import lang from '../lang/index';
import Dl from '../component/download';

class Download extends Component {
    constructor(props) {
        super(props);

        this.state = {
            apple: '',
            google: '',
            android: '',
        }

        this.downloads = [{
                key: 'android',
                channel: 'Android',
                text: 'Android Apk',
                link: Dl.downloadUrl['android'],
            },
            {
                key: 'apple',
                channel: 'IOS',
                text: 'App Store',
                link: Dl.downloadUrl['apple'],
            },
            {
                key: 'google',
                channel: 'Google',
                text: 'Google Play',
                link: Dl.downloadUrl['google'],
            }
        ]
    }

    componentDidMount() {
        this.renderQrcode();
    }

    renderQrcode = () => {
        let android = $(this.refs.android);
        let ios = $(this.refs.apple);
        let google = $(this.refs.google);

        android.qrcode({
            text: android.data('link'),
            width: 90,
            height: 90,
            render: "canvas"
        });

        ios.qrcode({
            text: ios.data('link'),
            width: 90,
            height: 90,
            render: "canvas"
        });

        google.qrcode({
            text: google.data('link'),
            width: 90,
            height: 90,
            render: "canvas"
        });
    }


    onClick(channel) {
        UP.Global.DA.add({
            eventName: 'Download',
            action: 'click',
            label: channel
        });
    }

    render() {
        return (
            <div className="download-pop">  
                <div className="download-pop-hd">
                    <i></i>
                    <h4>{lang.template('扫码下载Uplive客户端')}</h4>
                </div>
                <div className="download-pop-bd">
                    <ul>
                        {
                            this.downloads.map((item, index)=>{
                                return (
                                     <li className={item.key} key={item.key} >
                                        <div className="qrcode" ref={item.key} data-link={item.link}><i></i></div>
                                        <a onClick={this.onClick.bind(this, item.channel)} href={item.link} target="_blank"><i></i><span className="txt">{item.text}</span></a>
                                    </li>
                                )
                            })
                        }
                    </ul>
                </div>
            </div>
        );
    }
}

export default Download;


// WEBPACK FOOTER //
// ./js/header/download.js